export function distinctValues(list: any[]) {
  return list.filter((elem, pos, arr) => arr.indexOf(elem) === pos);
}


// WEBPACK FOOTER //
// ./src/utils/lists.ts